import { useQuery } from 'react-query';
import { customerBusinessService } from 'src/services';

interface IGetFavoritesQueryParams {
    size: number;
    location_id?: number;
}
const getDevices = async () => {
    const response = await customerBusinessService.authenticatedDevicesList();
    return response.data.data;
};

export default function useGetAuthenticatedDevices(
) {
    return useQuery('authDevices', () => getDevices(), {
        retry: false,
        staleTime: 0,
        cacheTime: 0,
    });
}
